module.exports = __webpack_public_path__ + "img/jazz-cabbage.0e32cff1.png";